import './header.less'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { IconButton, Logo, ModelListIcon, NavThirdLevelButton } from 'bimui'
import { ReactComponent as DocumentSvg } from 'bimui/dist/c1/icons/document.svg';
import { useContext, useEffect, useState } from 'react';
import { findProjectDetail } from '@/declare/api/project/project';
import { Project } from '@/declare/interface/project/project';
import localStore, { USER_NAME } from '../../../store/local-store';
import { IconBase } from 'bimui';
import { UserFeedbackActiveBtn } from '@/components/user-feedback';
import { RegisterStatus } from '@/store/register-store';
import { EngineContext, RegisterContext } from '@/App';
import { File } from '@/declare/interface/project/file';
import { Major } from '@/declare/interface/project/major';
import { Tooltip, message } from 'antd';
import { ReactComponent as ScreenSvg } from './icons/screen.svg';
import { ReactComponent as ScreenWhiteSvg } from './icons/screen-white.svg';
import { findFileByUuid } from '@/declare/api/project/file';
import { ReactComponent as HelpSvg } from 'bimui/dist/c1/icons/help-black.svg';
import { ReactComponent as UserSvg } from 'bimui/dist/c1/icons/user_16.svg';

export interface IProps {
    feedbackVisible: boolean,
    changeFeedbackVisible: (value: boolean) => void
    changeUserHelpVisible: (value: boolean) => void // 用户帮助是否可见
}
/**
 * 主页面顶部布局
 * @param props 
 * @returns 
 */
export default function ProjectHeader(props: IProps) {
    const { feedbackVisible, changeFeedbackVisible, changeUserHelpVisible } = props;
    /**
     * 路由导航函数，用于跳转页面。
     */
    const navigate = useNavigate();

    const registerContext = useContext<RegisterStatus>(RegisterContext);

    const [currentProject, setCurrentProject] = useState<Project>();

    const [userName, setUserName] = useState<string>('');

    const location = useLocation(); // 用于监听路由变化

    /**
     * 项目名称
     */
    const [projectName, setProjectName] = useState<string>()
    /**
     * 模型
     */
    const [file, setFile] = useState<File>(null)

    /**
     * 项目编号
     */
    const { projectUuid } = useParams();

    /**
     * 专业label列表
     */
    const [majorList, setMajorList] = useState<Major[]>([])

    /**
     * 是否激活全屏模式
     */
    const [screenActive, setScreenActive] = useState(true);
    /**
     * 设置全屏状态的鼠标悬浮状态
     */
    const [isScreenHovered, setIsScreenHovered] = useState(false);

    const { engine } = useContext(EngineContext); // 获取上下文

    useEffect(() => {
        let majorList: Major[] = registerContext.majors;
        setMajorList(majorList)
    }, [])

    /**
     * 引擎初始化后执行
     */
    useEffect(() => {
        if (!engine) return;
        const root = document.getElementById('viewport');
        if (!root) return;
        document.addEventListener('keydown', handleKeyDown);
        return (() => {
            document.removeEventListener('keydown', handleKeyDown);
        })
    }, [engine])

    const handleKeyDown = (event) => {
        if (event.code === "F11") {
            event.preventDefault();  // 阻止默认的F11行为
            toggleFullscreen();  // 调用toggleFullscreen切换全屏状态
        }
    }

    useEffect(() => {
        findProjectDetail(projectUuid).then(res => {
            setCurrentProject(res.data);
        })
        setUserName(localStore.get(USER_NAME) || '');
    }, [projectUuid])

    /**
     * 监听浏览器的全屏状态变化,修改全屏按钮的状态
     */
    useEffect(() => {
        const onFullScreenChange = () => {
            const isFullScreen = !!document.fullscreenElement;
            setScreenActive(isFullScreen); // 全屏变化时重新设置状态
        };

        document.addEventListener('fullscreenchange', onFullScreenChange);

        // 清理监听器
        return () => {
            document.removeEventListener('fullscreenchange', onFullScreenChange);
        };
    }, []);



    useEffect(() => {
        const match = location.pathname.match(/^\/projects\/([^/]+)(?:\/models\/([^/]+))?/);
        const pUuid = match?.[1];
        const mUuid = match?.[2];

        if (pUuid) {
            findProjectDetail(pUuid).then(res => {
                let data: Project = res.data
                setProjectName(data?.name)
            })
        }
        if (mUuid) {
            findFileByUuid(mUuid).then(res => {
                let data: File = res.data
                setFile(data)
            })
        }

    }, [location]);

    /**
     * 处理鼠标进入全屏按钮事件
     */
    const handleMouseEnterScreen = () => {
        setIsScreenHovered(true);
    };
    /**
     * 处理鼠标离开全屏按钮事件
     */
    const handleMouseLeaveScreen = () => {
        setIsScreenHovered(false);
    };


    /**
     * 处理进入全屏和退出全屏
     */
    const toggleFullscreen = () => {
        // 检查当前是否已经在全屏状态
        const isFullScreen = document.fullscreenElement

        if (isFullScreen) {
            // 如果已经是全屏状态，执行退出全屏
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
            setScreenActive(false);  // 更新全屏状态
        } else {
            // 如果当前不是全屏状态，执行进入全屏
            const elem = document.documentElement;
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            }
            setScreenActive(true);  // 更新全屏状态
        }
    };


    return (
        <div className="project-header-container">
            <Logo wrapClassName='top-logo' onClick={() => { navigate(`/desktop`) }} />
            <div className='bread-nav-item project'>
                {projectName && (projectName + " · ")}
                {file && majorList.find(item => item.uuid == file.majorUuid) && (" " + majorList.find(item => item.uuid == file.majorUuid).name + " ·")}
                {file && (" " + file.name)}
            </div>
            <span className='fill-remaining-space'></span>


            <UserFeedbackActiveBtn visible={feedbackVisible} changeVisible={(value) => changeFeedbackVisible(value)} />
            <Tooltip title="帮助"><div style={{ width: '24px', marginRight: '8px' }}><NavThirdLevelButton icon={<HelpSvg />} onClick={() => changeUserHelpVisible(true)} ></NavThirdLevelButton></div></Tooltip>

            <div className='user-panel'>
                {/* <IconBase className='avatar-image' /> */}
                <UserSvg />
                <span className='font-12_16-regular'>{userName}</span>
            </div>

            {/*  全屏 */}
            {!screenActive &&
                <div className="switch-group" style={{ backgroundColor: isScreenHovered ? "#d3e2e5" : "#FFFFFF" }} >
                    <Tooltip title="全屏(F11)" color="#555555" mouseEnterDelay={0} mouseLeaveDelay={0} arrow={false}>
                        <div
                            className="system-ope"
                            style={{ width: "18px" }}
                            onClick={toggleFullscreen}
                            onMouseEnter={handleMouseEnterScreen}
                            onMouseLeave={handleMouseLeaveScreen}
                        >
                            <ScreenSvg />
                        </div>
                    </Tooltip>
                </div>
            }
            {screenActive &&
                <div className="switch-group" style={{ backgroundColor: isScreenHovered ? "#d3e2e5" : "#11788f" }} >
                    <Tooltip title="全屏(F11)" color="#555555" mouseEnterDelay={0} mouseLeaveDelay={0} arrow={false}>
                        <div
                            className="system-ope"
                            style={{ width: "18px" }}
                            onClick={toggleFullscreen}
                            onMouseEnter={handleMouseEnterScreen}
                            onMouseLeave={handleMouseLeaveScreen}
                        >
                            {isScreenHovered ? <ScreenSvg /> : <ScreenWhiteSvg />}
                        </div>
                    </Tooltip>
                </div>
            }
        </div >
    )
}
